import React from 'react';
import { MdPayments } from 'react-icons/md';
import type { Service } from '../../types';
import { getServiceName, getServiceLogo, getServiceMimeType, getServiceEntity } from './helpers';

// Service Item Component
export interface ServiceItemProps {
  service: Service;
  onClick: () => void;
}

const ServiceItem: React.FC<ServiceItemProps> = ({ service, onClick }) => {
  const logo = getServiceLogo(service);
  const mimeType = getServiceMimeType(service);

  return (
    <button
      onClick={onClick}
      className="flex flex-col items-center gap-2 p-4 bg-white rounded-xl border border-pagali-gray-100 hover:border-pagali-primary hover:shadow-md transition-all text-center group"
    >
      {logo ? (
        <img
          src={`data:${mimeType};base64,${logo}`}
          alt={getServiceName(service)}
          className="w-16 h-16 rounded-full object-contain bg-pagali-gray-50 p-2 ring-2 ring-pagali-gray-100 group-hover:ring-pagali-primary transition-all"
        />
      ) : (
        <div className="w-16 h-16 rounded-full bg-pagali-gray-100 flex items-center justify-center ring-2 ring-pagali-gray-100 group-hover:ring-pagali-primary transition-all">
          <MdPayments className="text-2xl text-pagali-gray-400" />
        </div>
      )}
      <div className="min-w-0 w-full">
        <h4 className="font-semibold text-sm text-pagali-gray-800 truncate">{getServiceName(service)}</h4>
        <p className="text-xs text-pagali-gray-500 truncate">{getServiceEntity(service)}</p>
      </div>
    </button>
  );
};

export default ServiceItem;
